import ChatBotIcon from './../../svg/ChatBot';
import React, { useState, lazy, Suspense, useImperativeHandle, forwardRef } from 'react';
import { Button, Drawer, Space } from 'antd';
import './ChatbotUI.css';
import { CloseOutlined, FileTextOutlined } from '@ant-design/icons';

const AttachFileMoadal = lazy(() => import('./AttachFileModal'));

const ChatBot = lazy(() => import('./ChatBot'));

const ChatbotUI = forwardRef(({ triggerButton = true }, ref) => {
  const [isDrawerVisible, setIsDrawerVisible] = useState(false);
  const [isAttachModalOpen, setIsAttachModalOpen] = useState(false);

  useImperativeHandle(ref, () => ({
    openDrawer: () => setIsDrawerVisible(true),
  }));
  const handleAttachModalClick = () => {
    setIsAttachModalOpen(true);
  };

  const handleAttachModalClose = () => {
    setIsAttachModalOpen(false);
  };

  return (
    <>
      <Drawer
        title={
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Space align="center">
              <img src="/img/star-06.svg" alt="Star Icon" />

              <span style={{ fontWeight: 500 }}>OneDoc AI</span>
            </Space>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <Button
                icon={<FileTextOutlined />}
                style={{
                  fontSize: 20,
                }}
                onClick={handleAttachModalClick}
                type="text"
              />
              {isAttachModalOpen && (
                <Suspense fallback={<div>Loading...</div>}>
                  <AttachFileMoadal isModalOpen={isAttachModalOpen} onClose={handleAttachModalClose} />
                </Suspense>
              )}
              <CloseOutlined
                onClick={() => setIsDrawerVisible(false)}
                style={{ cursor: 'pointer', fontSize: '16px' }}
              />
            </div>
          </div>
        }
        placement="right"
        onClose={() => setIsDrawerVisible(false)}
        open={isDrawerVisible}
        width={600}
        bodyStyle={{
          padding: '10px',
          backgroundColor: '#F5F5F5',
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
        }}
        headerStyle={{ backgroundColor: '#F5F5F5' }}
        closable={false}
      >
        {isDrawerVisible && (
          <Suspense fallback={null}>
            <ChatBot setIsDrawerVisible={(data) => setIsDrawerVisible(data)} />
          </Suspense>
        )}
      </Drawer>
      {triggerButton && (
        <Button
          type="text"
          shape="circle"
          icon={<ChatBotIcon />}
          onClick={() => setIsDrawerVisible(true)}
          style={{
            backgroundColor: 'var(--box-background-color)',
            zIndex: 100,
            position: 'fixed',
            bottom: 20,
            right: 20,
            width: 48,
            height: 48,
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
            border: '1px solid #e0e0e0',
          }}
          aria-label="Chatbot"
        />
      )}
    </>
  );
});

export default ChatbotUI;
